import { createEntityDeps } from '@st/use/composables'

const [useBookmakerDeps, provideBookmakerDeps] = createEntityDeps<{
  hasOutcome: (uniqId: string) => boolean
}>('bookmaker')

export { useBookmakerDeps, provideBookmakerDeps }
